module.exports = __webpack_public_path__ + "fail.svg?6035dcd7bd2132b50571b2c4990b718a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fail.svg
// module id = 65
// module chunks = 0